// Expose the API instance for backward compatibility
// Note: The main instance is created in help-center-main.js and exposed via window.helpCenterInstance
// We'll expose the API class for any external usage
import { HelpCentreAPI } from "./help-center-api.js";
window.HelpCentreAPI = HelpCentreAPI;
